import { useEffect, useState } from 'react';

export function useClock() {
  const [clock, setClock] = useState({ time: '--:--:--', date: '', day: '' });

  useEffect(() => {
    const tick = () => {
      const n = new Date();
      setClock({
        time: n.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }),
        date: n.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: '2-digit' }),
        day: n.toLocaleDateString('en-GB', { weekday: 'long' }),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return clock;
}